import { Buffer } from 'buffer';
import Blank from 'assets/blank.png';
import { Pagination } from '@mui/material';
import {
  gridPageCountSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';

export const findOnArray = (value, arr = [], field) => {
  const rec = arr.find((i) => i.value === value);
  if (field) {
    return rec?.[field] || null;
  }
  return rec || null;
};

export const getImageFromBuffer = (buffer) => {
  if (buffer) {
    return (
      'data:image/png;base64,' + new Buffer.from(buffer).toString('base64')
    );
  }
  return Blank;
};

export const CustomPagination = () => {
  const gridRef = useGridApiContext();
  const count = useGridSelector(gridRef, gridPageCountSelector);
  return (
    <Pagination
      color="primary"
      count={count}
      onChange={(_, value) => gridRef?.current?.setPage(value - 1)}
    />
  );
};
